"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignUpTemplate = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
var logo_google_png_1 = __importDefault(require("../../../assets/logo_google.png"));
require("../../../index.css");
var button_1 = require("../../action/button");
var iconButton_1 = require("../../action/iconButton");
var form_1 = require("../../input/form");
var SignUpTemplate = /** @class */function (_super) {
  __extends(SignUpTemplate, _super);
  function SignUpTemplate() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.handleSelectSignUpOptions = function (provider) {
      _this.props.onChangeProvider(provider);
    };
    _this.renderEachProvider = function (eachProvider, type) {
      switch (eachProvider) {
        case "email":
          return react_1.default.createElement(button_1.Button, {
            type: type,
            key: eachProvider,
            className: "w-full",
            text: "Sign Up With Email",
            onClick: _this.handleSelectSignUpOptions.bind(_this, "email"),
            icon: react_1.default.createElement(outline_1.EnvelopeIcon, {
              className: "h-6 w-6 mr-3"
            })
          });
        case "google":
          return react_1.default.createElement(button_1.Button, {
            type: type,
            key: eachProvider,
            className: "w-full",
            text: "Sign Up With Google",
            onClick: _this.handleSelectSignUpOptions.bind(_this, "google"),
            icon: react_1.default.createElement("img", {
              src: logo_google_png_1.default,
              alt: "",
              className: "h-6 w-6 mr-3"
            })
          });
        case "phone":
          return react_1.default.createElement(button_1.Button, {
            type: type,
            key: eachProvider,
            className: "w-full",
            text: "Sign Up With Phone",
            onClick: _this.handleSelectSignUpOptions.bind(_this, "phone"),
            icon: react_1.default.createElement(outline_1.DevicePhoneMobileIcon, {
              className: "h-6 w-6 mr-3"
            })
          });
        default:
          return react_1.default.createElement(react_1.default.Fragment, null);
      }
    };
    _this.renderOtherProvidedContent = function () {
      var otherProviderList = [];
      _this.props.provider.map(function (eachProvider) {
        if (_this.props.defaultProvider !== eachProvider) {
          otherProviderList.push(_this.renderEachProvider(eachProvider, "icon"));
        }
        return null;
      });
      return otherProviderList;
    };
    _this.renderContent = function () {
      if (_this.props.type && _this.props.formList.steps.length - 1 >= _this.props.stepIndex) {
        return react_1.default.createElement(form_1.Form, {
          className: "mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8",
          refList: _this.props.formList.steps[_this.props.stepIndex].refs,
          ref: _this.props.formList.steps[_this.props.stepIndex].formRef,
          handleComplete: function () {
            if (_this.props.onCompleteEachStep) {
              _this.props.onCompleteEachStep();
            }
          }
        }, _this.props.formList.steps[_this.props.stepIndex].components.map(function (eachComponents) {
          return eachComponents;
        }), react_1.default.createElement("div", {
          className: "justify-end sm:col-span-2 sm:flex sm:ml-8"
        }, (_this.props.formList.steps.length - 1) % 2 === 0 && react_1.default.createElement("div", {
          className: "hidden sm:block"
        }), react_1.default.createElement(button_1.Button, {
          className: "w-full mt-4 sm:w-1/2",
          text: _this.props.formList.steps.length - 1 === _this.props.stepIndex ? "Submit" : "Next",
          size: "small",
          type: "normal",
          onClick: _this.props.formList.steps[_this.props.stepIndex].onHandleComponents
        })));
      } else {
        return react_1.default.createElement(react_1.default.Fragment, null);
      }
    };
    return _this;
  }
  SignUpTemplate.prototype.render = function () {
    var defaultClassName = "relative overflow-hidden py-10 px-6 sm:px-10 xl:p-12";
    if (this.props.leftClassName) {
      defaultClassName += " ".concat(this.props.leftClassName);
    }
    return react_1.default.createElement("div", {
      className: "grid grid-cols-1 lg:grid-cols-3"
    }, react_1.default.createElement("div", {
      className: defaultClassName
    }, this.props.leftComponents), react_1.default.createElement("div", {
      className: "py-10 px-6 sm:px-10 lg:col-span-2 xl:p-12"
    }, !this.props.type && react_1.default.createElement("h3", {
      className: "text-lg font-medium text-warm-gray-900"
    }, "Choose A Sign Up Option"), this.props.type && this.props.provider.length > 1 && !this.props.preventBack && react_1.default.createElement(iconButton_1.IconButton, {
      icon: react_1.default.createElement(outline_1.ChevronLeftIcon, {
        className: "h-5 w-5 text-primary-600",
        "aria-hidden": "true"
      }),
      className: "rounded-md",
      onClick: this.props.stepIndex === 0 ? this.handleSelectSignUpOptions.bind(this, "") : this.props.handleUpdateStepIndex.bind(this, this.props.stepIndex - 1)
    }), this.renderContent(), react_1.default.createElement("form", {
      className: "mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
    }, !this.props.type && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "hidden sm:block"
    }), this.renderEachProvider(this.props.defaultProvider, "normal")), this.props.provider.length > 1 && !this.props.type && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "flex flex-row items-center sm:col-span-2"
    }, react_1.default.createElement("div", {
      className: "flex-grow border-t border-gray-300"
    }), react_1.default.createElement("span", {
      className: "text-sm px-2 text-gray-500"
    }, "Or Continue With"), react_1.default.createElement("div", {
      className: "flex-grow border-t border-gray-300"
    })), this.props.provider.length <= 2 && react_1.default.createElement("div", {
      className: "hidden sm:block"
    }), this.renderOtherProvidedContent()), this.props.version && react_1.default.createElement("div", {
      className: "sm:col-span-2 sm:flex sm:justify-end"
    }, react_1.default.createElement("span", {
      className: "text-xs text-gray-500"
    }, "Version ", this.props.version)))));
  };
  return SignUpTemplate;
}(react_1.Component);
exports.SignUpTemplate = SignUpTemplate;